import { z } from "zod";
import { API_V1_PREFIX, apiRequestJson } from "../api-client";

const auditLogChangeSchema = z.object({
  before: z.unknown().optional(),
  after: z.unknown().optional(),
});

const auditLogPayloadSchema = z.object({
  summary: z.string(),
  changes: z.record(z.string(), auditLogChangeSchema).optional(),
  context: z.record(z.string(), z.unknown()).optional(),
});

const auditLogActorSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().email(),
});

export const auditLogEntrySchema = z.object({
  id: z.string(),
  userId: z.string().nullable(),
  actor: auditLogActorSchema.nullable(),
  action: z.string(),
  entityType: z.string(),
  entityId: z.string(),
  payload: auditLogPayloadSchema,
  createdAt: z.string(),
});

export const auditLogListResponseSchema = z.object({
  data: z.array(auditLogEntrySchema),
  nextCursor: z.string().nullable(),
});

export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>;
export type AuditLogListResponse = z.infer<typeof auditLogListResponseSchema>;

export type AuditLogParams = {
  limit?: number;
  cursor?: string;
  action?: string;
  entityType?: string;
  dateFrom?: string;
  dateTo?: string;
};

export async function listAuditLogs(params?: AuditLogParams): Promise<AuditLogListResponse> {
  const search = new URLSearchParams();
  if (params?.limit !== undefined) search.set("limit", String(params.limit));
  if (params?.cursor) search.set("cursor", params.cursor);
  if (params?.action) search.set("action", params.action);
  if (params?.entityType) search.set("entityType", params.entityType);
  if (params?.dateFrom) search.set("dateFrom", params.dateFrom);
  if (params?.dateTo) search.set("dateTo", params.dateTo);

  const qs = search.size > 0 ? `?${search.toString()}` : "";
  const path = `${API_V1_PREFIX}/audit-logs${qs}`;

  return apiRequestJson({
    path,
    responseSchema: auditLogListResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
}
